import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, Package, ClipboardList, Settings as SettingsIcon, ExternalLink } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { useAdminAuth } from "@/context/AdminAuthContext";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminSettings from "@/pages/admin/AdminSettings";

const TABS = [
  { id: "products", label: "Products", icon: Package },
  { id: "orders", label: "Orders", icon: ClipboardList },
  { id: "settings", label: "Settings", icon: SettingsIcon },
];

export default function AdminDashboard() {
  const { user, logout } = useAdminAuth();
  const [tab, setTab] = useState("products");

  return (
    <div className="min-h-screen bg-slate-100">
      <Seo title="Admin Dashboard | CA HVAC Direct" description="Admin dashboard" />
      <header className="border-b border-slate-200 bg-slate-950 text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2.5">
            <img src="/logo.png" alt="" className="h-9 w-9 object-contain" />
            <span className="font-heading text-sm font-black tracking-tight">CA HVAC DIRECT · Admin</span>
          </div>
          <div className="flex items-center gap-2">
            <Button asChild variant="ghost" size="sm" className="text-slate-300 hover:text-white"><Link to="/" target="_blank"><ExternalLink className="h-4 w-4" /> View Store</Link></Button>
            <Button variant="ghost" size="sm" onClick={logout} className="text-slate-300 hover:text-white" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Sign out</Button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center gap-2">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`inline-flex items-center gap-2 rounded-sm px-4 py-2 text-sm font-semibold transition-colors ${tab === t.id ? "bg-sky-700 text-white" : "bg-white text-slate-700 hover:bg-slate-50"}`}
                data-testid={`admin-tab-${t.id}`}
              >
                <Icon className="h-4 w-4" /> {t.label}
              </button>
            );
          })}
        </div>

        {tab === "products" && <AdminProducts />}
        {tab === "orders" && <AdminOrders />}
        {tab === "settings" && <AdminSettings />}
      </div>
    </div>
  );
}
